export default {
  title: 'アラート設定',
  sectionAlertRule: 'アラート監視ルール',
  alertEnabled: '機能スイッチ',
  alertEnabledDesc:
    '有効にすると、QRコードが設定したスキャン回数に達した際に自動的にアラートが発動します。',
  scanCountThreshold: 'アラートスキャン回数閾値',
  scanCountThresholdUnit: '回',
  scanCountThresholdDesc:
    'アラート発動のスキャン回数を設定します。QRコードのスキャン回数がこの値に達するとアラートが発動します。',
  sectionAutoDispose: '自動処理戦略',
  autoDisposeEnabled: '機能スイッチ',
  autoDisposeEnabledDesc:
    '有効にすると、QRコードがアラートを発動した際に自動的にQRコードを無効化し、スキャンを阻止します。',
  triggerCondition: 'トリガー条件',
  triggerOnScanCount: 'スキャン回数アラート発動時',
  executeAction: '無効化操作実行',
  disableScopeSingle: 'アラート対象のQRコードのみ無効化',
  disableScopeBatch: '同バッチの全QRコードを無効化',
  disableTip: '無効化ヒント（消費者向けテキスト）',
  disableTipDesc:
    '消費者が無効化されたQRコードをスキャンした際に表示されるメッセージを設定します。',
  disableTipPlaceholder: '無効化メッセージを入力してください',
  save: '保存',
  saveSuccess: '保存しました',
};
